"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_hooks_1 = require("@l2p/common-hooks");
var swr_hooks_1 = require("@l2p/swr-hooks");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var ProvidersSelectLight = function (_a) {
    var _b;
    var provider = _a.provider, setProvider = _a.setProvider, _c = _a.withMobileBottomList, withMobileBottomList = _c === void 0 ? false : _c, _d = _a.items, items = _d === void 0 ? [] : _d, _e = _a.allLabelKey, allLabelKey = _e === void 0 ? 'allProviders' : _e;
    var translateLocale = (0, swr_hooks_1.useLocaleTranslations)();
    var hasItems = (items === null || items === void 0 ? void 0 : items.length) > 0;
    var wrapperRef = (0, react_1.useRef)(null);
    var _f = (0, react_1.useState)(false), isOpen = _f[0], setIsOpen = _f[1];
    var t = (0, next_intl_1.useTranslations)('translation');
    var _g = (0, swr_hooks_1.useGetProviders)({
        isAutoCall: !hasItems,
    }).data, providers = _g === void 0 ? [] : _g;
    var selectItems = hasItems ? items : providers;
    var currentProvider = selectItems === null || selectItems === void 0 ? void 0 : selectItems.find(function (p) { return p.id === (provider === null || provider === void 0 ? void 0 : provider.id); });
    (0, common_hooks_1.useOnClickOutside)(wrapperRef, function () { return setIsOpen(false); });
    var allLabel = t(allLabelKey);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container, ref: wrapperRef },
        react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.selectBtn, " ").concat(isOpen ? styles_module_scss_1.default.isOpen : ''), onClick: function () { return setIsOpen(!isOpen); } },
            currentProvider ? translateLocale(currentProvider === null || currentProvider === void 0 ? void 0 : currentProvider.title) : allLabel,
            react_1.default.createElement("img", { src: "/img/icons/arrow-up.svg", alt: "arrow-up" })),
        isOpen && (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.providers, " ").concat(withMobileBottomList ? styles_module_scss_1.default.withMobileBottomList : '') }, (_b = __spreadArray([{ id: null, title: allLabel }], (selectItems || []), true)) === null || _b === void 0 ? void 0 : _b.map(function (p) {
            var _a;
            return (react_1.default.createElement("div", { key: (_a = p === null || p === void 0 ? void 0 : p.id) !== null && _a !== void 0 ? _a : 'all', onClick: function () {
                    setProvider((p === null || p === void 0 ? void 0 : p.id) ? p : null);
                    setIsOpen(false);
                } }, translateLocale(p === null || p === void 0 ? void 0 : p.title)));
        })))));
};
exports.default = ProvidersSelectLight;
